import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";

let chartsRegistered = false;

export const ensureChartsRegistered = () => {
  if (chartsRegistered) return;

  ChartJS.register(
    ArcElement,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
  );
  ChartJS.defaults.color = "#ffffff";
  ChartJS.defaults.font.family = "'Poppins', Inter, system-ui, sans-serif";
  ChartJS.defaults.font.size = 12;
  chartsRegistered = true;
};
